import { MensagemForm } from "core/features/mensagens/typings";
import React, { useContext, useEffect, useRef, useState } from "react";
import DrawerNovaMensagem from ".";

interface MensagemModalContextValues {
  isOpenDrawer: boolean;
  onOpen: (onSuccess?: () => any) => any;
  onClose: () => any;
  openWithDefaultValues: (
    values: Partial<MensagemForm>,
    onSuccess?: () => any,
    compact?: boolean
  ) => any;
}

const MensagemModalContext = React.createContext<MensagemModalContextValues>({
  isOpenDrawer: false,
  onOpen: () => {},
  onClose: () => {},
  openWithDefaultValues: () => {},
});

function MensagemModalContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const onSuccessRef = useRef<Function | undefined>();
  const [defaultValues, setDefaultValues] = useState<
    Partial<MensagemForm> | undefined
  >();
  const [compact, setCompact] = useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  useEffect(() => {
    if (defaultValues) {
      setIsOpenDrawer(true);
    }
  }, [defaultValues]);

  useEffect(() => {
    if (!isOpenDrawer) {
      setDefaultValues(undefined);
      onSuccessRef.current = undefined;
    }
  }, [isOpenDrawer]);

  const onOpen = (onSuccess?: () => any) => {
    setIsOpenDrawer(true);
    onSuccessRef.current = onSuccess;
  };

  const onClose = () => setIsOpenDrawer(false);

  const openWithDefaultValues = (
    values: Partial<MensagemForm>,
    onSuccess?: () => any,
    compact = false
  ) => {
    setDefaultValues(values);
    setCompact(compact);
    onSuccessRef.current = onSuccess;
  };

  return (
    <MensagemModalContext.Provider
      value={{ isOpenDrawer, onOpen, onClose, openWithDefaultValues }}
    >
      {isOpenDrawer ? (
        <DrawerNovaMensagem
          compact={compact}
          onSuccess={() => {
            setIsOpenDrawer(false);
            onSuccessRef.current?.();
          }}
          onClose={() => setIsOpenDrawer(false)}
          defaultValues={defaultValues}
        />
      ) : null}
      {children}
    </MensagemModalContext.Provider>
  );
}

export function useMensagemModal() {
  return useContext(MensagemModalContext);
}

export default MensagemModalContextProvider;
